export default "__VITE_ASSET__8468ed3d__"